import { IconButton } from 'design-system';
import { ThumbsDown, ThumbsUp } from 'lucide-react';

import { useRateAnswerTracking } from './useRateAnswerTracking';

type RateAnswerProps = {
  prompt: string;
  response: unknown[];
  conversationId: string;
  version: number;
  rating: -1 | 0 | 1 | undefined;
  onRate: (rating: -1 | 1) => void;
};

const RateAnswer = ({
  prompt,
  response,
  conversationId,
  version,
  rating = 0,
  onRate
}: RateAnswerProps) => {
  const { track } = useRateAnswerTracking({ prompt, response, conversationId, version });

  return (
    <>
      <IconButton
        label='Rate response helpful'
        size='icon-sm'
        data-testid='thumb-up'
        disabled={rating === 1}
        className='disabled:opacity-100'
        variant='ghost'
        onClick={() => {
          onRate(1);
          track(1);
        }}
      >
        <ThumbsUp className={rating === 1 ? 'size-5 fill-current' : 'size-5'} />
      </IconButton>
      <IconButton
        label='Rate response unhelpful'
        size='icon-sm'
        data-testid='thumb-down'
        disabled={rating === -1}
        className='disabled:opacity-100'
        variant='ghost'
        onClick={() => {
          onRate(-1);
          track(-1);
        }}
      >
        <ThumbsDown className={rating === -1 ? 'size-5 fill-current' : 'size-5'} />
      </IconButton>
    </>
  );
};

export default RateAnswer;
